import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="termcond">
      <p>Please read and accept our Terms and Conditions before proceeding:</p>
      <div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel
          nisi eget sem suscipit euismod. Fusce aliquet consequat nulla, nec
          ullamcorper libero dictum at. Etiam facilisis justo vitae nulla
          iaculis, ut scelerisque neque porttitor. Cras lacinia lorem vel
          sagittis malesuada. Nam vehicula gravida purus at placerat. Sed
          tristique volutpat vehicula.
        </p>
        <p>
          Vivamus nec ligula ut eros commodo tristique. Integer id libero non
          tortor viverra fermentum. Proin tincidunt accumsan nunc, sit amet
          convallis justo tempor sit amet. Cras sed sem id sapien pellentesque
          volutpat. Duis vitae tortor sapien.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
